import { request } from "@/utils/request";

// 获取子站点首页信息专栏等（已登录）
export const getIndexContent = (data) => {
  return request({
    url: "/cms/mall/publish/queryByCompanyIdAndPublishType",
    method: "POST",
    data: data,
  });
};

// 获取子站点首页信息专栏等（（未登录）
export const getIndexContentNoLogin = (data) => {
  return request({
    url: "/cms/public/publish/queryByCompanyIdAndPublishType",
    method: "POST",
    data: data,
  });
};

// 获取子站点首页轮播图（已登录）
export const getBannerList = (data) => {
  return request({
    url: "/cms/mall/cmsMap/queryByCompanyId",
    method: "POST",
    data: data,
  });
};

// 获取子站点首页轮播图（未登录）
export const getBannerListNoLogin = (data) => {
  return request({
    url: "/cms/public/cmsMap/queryByCompanyId",
    method: "POST",
    data: data,
  });
};

// 获取首页资讯列表（已登录）
export const getNewsList = (data) => {
  return request({
    url: "/cms/mall/information/queryByCompanyId",
    method: "POST",
    data: data,
  });
};

// 获取首页资讯列表（未登录）
export const getNewsListNoLogin = (data) => {
  return request({
    url: "/cms/public/information/queryByCompanyId",
    method: "POST",
    data: data,
  });
};

// 首页分类（登录）
export const ProductCategoryList = (data) => {
  return request({
    url: "/product/mall/selectPublishedProductCategoryList",
    method: "POST",
    data: data,
  });
};

// 首页分类（未登录）
export const ProductCategoryListNoLogin = (data) => {
  return request({
    url: "/product/public/selectPublishedProductCategoryListNoLogin",
    method: "POST",
    data: data,
  });
};

// 资质证照
export const queryJdeConfigByCode = (data) => {
  return request({
    url: "/user/public/queryJdeConfigByCode",
    method: "GET",
    data: data,
  });
};

// 获取全部栏目
export const queryByCompanyIdAndPublishTypeAll = (params) => {
  return request({
    url: `/cms/public/publish/queryByCompanyIdAndPublishTypeAll`,
    method: "post",
    data: params,
  });
};

// 公司介绍（文章类型 wzType: 3 为公司介绍，与 pc-seo subsite detailCompany 一致）
export const detailCompany = (data) => {
  return request({
    url: "/cms/public/articleDetail/queryPage",
    method: "POST",
    data,
  });
};
